import React, { useState } from 'react';
import { PasswordDetailsContainer } from './passwordValidatorStyled';
import Heading from '../typography';
import { COLORS } from '../../constants/style/color';

const PasswordValidatorContainer = ({ check }: { check: any }) => {
  const icon = <span className='material-symbols-outlined text-3xl'>check_circle</span>;

  return (
    <PasswordDetailsContainer>
      <>
        <div className=''>
          <div className='flex gap-x-4'>
            <div className={`icon ${check.longer ? 'icon-success' : ''}`}>{icon}</div>
            <Heading
              variant='body-xs'
              title='Must be at least 8 characters long'
              className='info'
              color={check.longer ? `${COLORS.Green}` : `${COLORS.Red}`}
            />
          </div>
          <div className='flex gap-x-4'>
            <div className={`icon ${check.lowerCase ? 'icon-success' : ''}`}>{icon}</div>
            <Heading
              variant='body-xs'
              title='Includes at least 1 lowercase'
              className='info'
              color={check.lowerCase ? `${COLORS.Green}` : `${COLORS.Red}`}
            />
          </div>
          <div className='flex gap-x-4'>
            <div className={`icon ${check.upperCase ? 'icon-success' : ''}`}>{icon}</div>
            <Heading
              variant='body-xs'
              title='Includes at least 1 uppercase'
              className='info'
              color={check.upperCase ? `${COLORS.Green}` : `${COLORS.Red}`}
            />
          </div>
          <div className='flex gap-x-4'>
            <div className={`icon ${check.isNumber ? 'icon-success' : ''}`}>{icon}</div>
            <Heading
              variant='body-xs'
              title='Must contain at least  1 Number'
              className='info'
              color={check.isNumber ? `${COLORS.Green}` : `${COLORS.Red}`}
            />
          </div>
          <div className='flex gap-x-4'>
            <div className={`icon ${check.hasSymbol ? 'icon-success' : ''}`}>{icon}</div>
            <Heading
              variant='body-xs'
              title='Must include at least 1 special character'
              className='info'
              color={check.hasSymbol ? `${COLORS.Green}` : `${COLORS.Red}`}
            />
          </div>
        </div>
      </>
    </PasswordDetailsContainer>
  );
};

export default PasswordValidatorContainer;
